/**
 * 授权逻辑入口
 * 支持 支付宝、微信、QQ、抖音
 */
import AliPayAuthorize from './authorizer/aliPayAuthorize';
import WxAuthorize from './authorizer/wxAuthorize';
import QqAuthorize from './authorizer/qqAuthorize';
import DouyinAuthorize from './authorizer/douyinAuthorize';
import PhoneNumAuthorize from './authorizer/phoneNumAuthorize';

import authUtils from './authUtils';

export default class Authorize {
  static authInstance = null;

  //根据授权类型调用不同授权类
  static getAuthorizeInstance(options) {
    const { authType } = options;
    if(authType === 'phoneNum') {
      return new PhoneNumAuthorize(options);
    }
    // 默认微信授权
    if(authUtils.browser().wechat) {
      return new WxAuthorize(options);
    } else if(authUtils.browser().aliPay) {
      // 支付宝授权
      return new AliPayAuthorize(options);
    } else if(authUtils.browser().qq) {
      // qq授权
      return new QqAuthorize(options);
    } else if(authUtils.browser().douyin) {
      return new DouyinAuthorize(options);
    } else {
      return new WxAuthorize(options);
    }
  }

  /**
   * 初始化授权, 检查授权回调
   * @param options
   * @returns {Promise<unknown>}
   */
  static initAuthorize(options = {}) {
    const { query = authUtils.getUrlQuery(), snsapiBase = false, ...params } = options;
    return new Promise((resolve, reject) => {
      this.authInstance = Authorize.getAuthorizeInstance({
        query,
        snsapiBase,
        ...params
      });
      // 检查是否是授权回调
      Authorize.checkAuthorize(this.authInstance, resolve, reject);

    });
  }

  /**
   * 启动授权
   * @param options
   * @returns {Promise<unknown>}
   */
  static startAuthorize(options = {}, forceAuth = false) {
    // 自定义授权参数
    if(Object.keys(options).length) {
      const { query = authUtils.getUrlQuery(), snsapiBase = false, ...params } = options;
      this.authInstance = Authorize.getAuthorizeInstance({
        query,
        snsapiBase,
        ...params
      });
    }

    // 防止重复授权 | 带了手机号说明是关联授权必须发起授权
    if(this.authInstance && this.authInstance.checkLogged() && !forceAuth && !options.phone) return;

    // // 开始授权
    Authorize.forwardAuthorize(this.authInstance);
  }

  /**
   * 初始化userInfo
   * @type {authUtils.createTempUser}
   */
  static createTempUser = authUtils.createTempUser;

  // 调整授权接口
  static forwardAuthorize(auth = this.authInstance, params) {
    //存储发起授权时间
    authUtils.saveStartAuthTime();
    auth.forward(params);
  }

  /**
   * 授权流程：
   * 1. 检查是否是授权成功后跳转的默认授权页（有code）， 如果是，则获取用户cookie信息，并获取用户信息  /return
   * 2. 检查是否存在openid，如果有，则用openid获取用户信息和cookie信息  /return
   * 3. 检查是否有cookie 如果有，直接获取用户信息 /return
   * 4. 以上皆不成立，则进入微信授权页 授权成功则进入
   */
  static checkAuthorize = async (auth, success, error) => {

    //检查授权回来，是否有code
    if(auth.checkCode() && authUtils.checkAuthorizeTime()) {
      //清空cookie
      authUtils.removeCookieUser();

      //清除授权之前的存储标记
      authUtils.removeLocalAuthTime();

      //通过code获取用户信息
      auth.getByCode()
        .then((json = {}) => {
          localStorage.setItem('authInfo', JSON.stringify(json));
          authUtils.saveCookieUser(json.data || json);
          success();
        }).catch(err => {
          error(err);
        });
    } else if(auth.checkOpenid()) {     //检查是否可以用openid登录
      authUtils.removeCookieUser();
      auth.getByOpenid()
        .then(json => {
          authUtils.saveCookieUser(json.data || json);
          success();
        }).catch(err => {
          error(err);
        });
    } else if(auth.checkLogged()) { //检查是否cookie合格
      success();
    } else if(auth.enterAuthorize()) {
      //检查是否进入授权
      Authorize.forwardAuthorize(auth);
    } else {
      // 生成临时用户信息
      await Authorize.createTempUser();
      success();
    }
  }
}

// 生成并存储localCode
authUtils.saveLocalCode();
